// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3K8xc","col":"Table_col__3Vu8l","fulfillmentStatus":"Table_fulfillmentStatus__M6omy","emailCol":"Table_emailCol__1w1eD"};